/* eslint-disable */
import * as Types from './types';

export type VideoSectionFragment = { __typename?: 'VideoSection', youtubeVideoId?: string | null, vimeoVideoId?: string | null, video?: { __typename?: 'Asset', url?: string | null, contentType?: string | null } | null, videoPoster?: { __typename?: 'Asset', title?: string | null, url?: string | null, height?: number | null, width?: number | null } | null };

export declare const VideoSectionFragment: import("graphql").DocumentNode;
export const VideoSectionFragmentDoc = /*#__PURE__*/ `
    fragment VideoSectionFragment on VideoSection {
  video {
    url
    contentType
  }
  youtubeVideoId
  vimeoVideoId
  videoPoster {
    title
    url
    height
    width
  }
}
    `;